// import pt from '../../../old/libs/pt';
import type { Language } from './languages';

type TranslationLeaf = { [L in Language]: string };
type TranslationNode = TranslationLeaf | { [key: string]: TranslationNode };

export const translation = {
  temp: {
    common: {
      silobag: {
        es: 'Silobolsa',
        en: 'Silobag',
        pt: 'Silos bolsa',
      },
      silobags: {
        es: 'Silobolsas',
        en: 'Silobags',
        pt: 'Silos bolsas',
      },
      organization: {
        es: 'Organización',
        en: 'Organization',
        pt: 'Organização',
      },
      organizations: {
        es: 'Organizaciones',
        en: 'Organizations',
        pt: 'Organizações',
      },
      organization_unavailable: {
        es: 'Organización no disponible',
        en: 'Organization not available',
        pt: 'Organização no disponível',
      },
      company: {
        es: 'Compañía',
        en: 'Company',
        pt: 'Empresa',
      },
      companies: {
        es: 'Compañías',
        en: 'Companies',
        pt: 'Empresas',
      },
      company_unavailable: {
        es: 'Compañía no disponible',
        en: 'Company not available',
        pt: 'Empresa no disponível',
      },
      countryside: {
        es: 'Establecimiento',
        en: 'Farm',
        pt: 'Estabelecimento',
      },
      countrysides: {
        es: 'Establecimientos',
        en: 'Farms',
        pt: 'Estabelecimentos',
      },
      countryside_unavailable: {
        es: 'Establecimiento no disponible',
        en: 'Farm not available',
        pt: 'Estabelecimiento no disponível',
      },
      countryside_zone: {
        es: 'Zonas / Sucursales',
        en: 'Zones / Branches',
        pt: 'Regiões',
      },
      lot: {
        es: 'Lote',
        en: 'Lot',
        pt: 'Talhão',
      },
      lots: {
        es: 'Lotes',
        en: 'Lots',
        pt: 'Talhões',
      },
      tags: {
        es: 'Etiquetas',
        en: 'Tags',
        pt: 'Etiquetas',
      },
      system_tags: {
        es: 'Etiquetas del sistema',
        en: 'System tags',
        pt: 'Etiquetas do sistema',
      },
      organization_tags: {
        es: 'Etiquetas de la organización',
        en: 'Organization tags',
        pt: 'Etiquetas da organização',
      },
      lot_unavailable: {
        es: 'Lote no disponible',
        en: 'Lot not available',
        pt: 'Talhão no disponível',
      },
      silosat: {
        es: 'SiloSat',
        en: 'SiloSat',
        pt: 'SiloSat',
      },
      silometrix: {
        es: 'SiloMetrix',
        en: 'SiloMetrix',
        pt: 'SiloMetrix',
      },
      tons: {
        es: 'Toneladas',
        en: 'Tons',
        pt: 'Toneladas',
      },
      inconsistencies: {
        es: 'Inconsistencias',
        en: 'Inconsistencies',
        pt: 'Inconsistências',
      },
      search: {
        es: 'Buscar',
        en: 'Search',
        pt: 'Buscar',
      },
      share: {
        es: 'Compartir',
        en: 'Share',
        pt: 'Compartilhar',
      },
      name: {
        es: 'Nombre',
        en: 'Name',
        pt: 'Nome',
      },
      services: {
        es: 'Servicios',
        en: 'Services',
        pt: 'Serviços',
      },
      id: {
        es: 'ID',
        en: 'ID',
        pt: 'ID',
      },
      specie: {
        es: 'Especie',
        en: 'Specie',
        pt: 'Cultura',
      },
      specie_unavailable: {
        es: 'Variedad no disponible',
        en: 'Variety not available',
        pt: 'Variedade no disponível',
      },
      product: {
        es: 'Producto',
        en: 'Product',
        pt: 'Produto',
      },
      closure: {
        es: 'Cierre',
        en: 'Closure',
        pt: 'Fechamento',
      },
      close: {
        es: 'Cerrar',
        en: 'Close',
        pt: 'Fechar',
      },
      closed: {
        es: 'Cerrados',
        en: 'Closed',
        pt: 'Fechados',
      },
      closures: {
        es: 'Cierres',
        en: 'Closures',
        pt: 'Fechamento em massa',
      },
      register: {
        es: 'Alta',
        en: 'Register',
        pt: 'Registro',
      },
      date: {
        es: 'Fecha',
        en: 'Date',
        pt: 'Data',
      },
      date_unavailable: {
        es: 'Fecha no disponible',
        en: 'Date not available',
        pt: 'Data no disponível',
      },
      bagging: {
        es: 'Embolsado',
        en: 'Bagging',
        pt: 'Embolsamento',
      },
      bagging_date: {
        es: 'Fecha de embolsado',
        en: 'Bagging date',
        pt: 'Data de embolsamento',
      },
      bagging_date_unavailable: {
        es: 'Fecha de embolsado no disponible',
        en: 'Bagging date not available',
        pt: 'Embolsamento no disponível',
      },
      humidity: {
        es: 'Humedad',
        en: 'Humidity',
        pt: 'Umidade',
      },
      bagging_humidity: {
        es: 'Humedad embolsado',
        en: 'Bagging Humidity',
        pt: 'Umidade inicial',
      },
      bagging_humidity_not_registered: {
        es: 'Humedad de embolsado no registrada',
        en: 'Bagging Humidity not registered',
        pt: 'Umidade de embolsamento não registrada',
      },
      last_calado: {
        es: 'Ultimo calado',
        en: 'Last quality sample',
        pt: 'Última calagem',
      },
      last_calado_humidity: {
        es: 'Humedad ultimo calado',
        en: 'Last quality sample humidity',
        pt: 'Umidade da última calagem',
      },
      last_calado_date: {
        es: 'Fecha ultimo calado',
        en: 'Last quality sample date',
        pt: 'Data da última calagem',
      },
      max_quality_revision: {
        es: 'Maximo calado',
        en: 'Maximum sample',
        pt: 'Calagem mais alta',
      },
      max_quality_revision_humidity: {
        es: 'Humedad maxima calado',
        en: 'Maximum sample humidity',
        pt: 'Umidade máxima em calagem',
      },
      max_quality_revision_humidity_date: {
        es: 'Fecha maximo calado',
        en: 'Maximum sample date',
        pt: 'Data da calagem mais alta',
      },
      total_extracted: {
        es: 'Total extraído',
        en: 'Total extracted',
        pt: 'Total extraído',
      },
      no_extraction_registered: {
        es: 'Sin extracciones registradas',
        en: 'No extractions registered',
        pt: 'Sem extrações registradas',
      },
      alerts: {
        es: 'Alertas',
        en: 'Alerts',
        pt: 'Alertas',
      },
      alert_level: {
        es: 'Nivel de alerta',
        en: 'Alert level',
        pt: 'Nível de alerta',
      },
      alert_level_movement: {
        es: 'Movimiento',
        en: 'Movement',
        pt: 'Movimento',
      },
      alert_level_quality_serious: {
        es: 'Calidad Grave',
        en: 'Severe quality',
        pt: 'Grave',
      },
      alert_level_quality_min: {
        es: 'Calidad Leve',
        en: 'Mild quality',
        pt: 'Atenção',
      },
      alert_level_optimum: {
        es: 'Optimo',
        en: 'Optimal',
        pt: 'Sem alertas',
      },
      without_data: {
        es: 'Sin datos',
        en: 'Without data',
        pt: 'Sem dados',
      },
      actions: {
        es: 'Acciones',
        en: 'Actions',
        pt: 'Ações',
      },
      weigth: {
        es: 'Peso',
        en: 'Weight',
        pt: 'Peso',
      },
      bagging_weigth: {
        es: 'Peso de embolsado',
        en: 'Bagging Weight',
        pt: 'Peso de embolsamento',
      },
      extracted_weight: {
        es: 'Peso de extracciones',
        en: 'Extracted Weight',
        pt: 'Peso de extrações',
      },
      weigth_unregistered: {
        es: 'Peso no registrado',
        en: 'Weight not registered',
        pt: 'Peso não registrado',
      },
      tooltip_sb_optimal: {
        es: 'SiloPro en estado optimo.',
        en: 'SiloPro in optimal state.',
        pt: 'SiloPro em ótimo estado.',
      },
      tooltip_sb_monitoring_alert: {
        es: 'Alerta de monitoreo detectada.',
        en: 'Monitoring alert detected.',
        pt: 'Alerta de monitoramento detectada.',
      },
      difference: {
        es: 'Diferencia',
        en: 'Difference',
        pt: 'Diferença',
      },
      coming_soon: {
        es: 'Próximamente',
        en: 'Coming soon',
        pt: 'Em breve',
      },
      export: {
        es: 'Exportar',
        en: 'Export',
        pt: 'Exportar',
      },
      exports: {
        es: 'Exportaciones',
        en: 'Exports',
        pt: 'Exportações',
      },
      quality_sample: {
        es: 'Muestra de calidad',
        en: 'Quality sample',
        pt: 'Amostra de qualidade',
      },
      harvest: {
        es: 'Cosecha',
        en: 'Harvest',
        pt: 'Safra',
      },
      harvest_unavailable: {
        es: 'Cosecha no disponible',
        en: 'Harvest not available',
        pt: 'Safra no disponível',
      },
      new_silobag: {
        es: 'Nuevo Silobolsa',
        en: 'New Silobag',
        pt: 'Novo Silo Bolsa',
      },
      register_silobag: {
        es: 'Alta silobolsa',
        en: 'Register silobag',
        pt: 'Registrar Silo Bolsa',
      },
      restore: {
        es: 'Restaurar',
        en: 'Restore',
        pt: 'Desarquivar',
      },
      closure_date: {
        es: 'Fecha de cierre',
        en: 'Closure date',
        pt: 'Data final',
      },
      stock_in_field: {
        es: 'Stock en campo',
        en: 'Stock in field',
        pt: 'Estoque em campo',
      },
      search_option: {
        es: 'Buscar opción',
        en: 'Search option',
        pt: 'Pesquisar opção',
      },
      actives: {
        es: 'Activas',
        en: 'Actives',
        pt: 'Ativas',
      },
      expand_list: {
        es: 'Ampliar lista',
        en: 'Expand list',
        pt: 'Ampliar lista',
      },
      return_to_selector: {
        es: 'Volver al selector',
        en: 'Return to selector',
        pt: 'Voltar ao seletor',
      },
      see_active_options: {
        es: 'Ver opciones activas',
        en: 'See active options',
        pt: 'Ver opções ativas',
      },
      range: {
        es: 'Rango',
        en: 'Range',
        pt: 'Período',
      },
      click_exclamation: {
        es: 'Click!',
        en: 'Click!',
        pt: 'Clicar!',
      },
      select_start_date: {
        es: 'Seleccionar fecha de inicio',
        en: 'Select start date',
        pt: 'Selecionar data de início',
      },
      select_closure_date: {
        es: 'Seleccionar fecha de cierre',
        en: 'Select closure date',
        pt: 'Selecionar data de fechamento',
      },
      slide_exclamation: {
        es: 'Deslizar!',
        en: 'Slide!',
        pt: 'Deslizar!',
      },
      save: {
        es: 'Guardar',
        en: 'Save',
        pt: 'Salvar',
      },
      return: {
        es: 'Volver',
        en: 'Return',
        pt: 'Voltar',
      },
      select_rows_to_continue: {
        es: 'Elegí una o más filas para continuar',
        en: 'Select one or more rows to continue',
        pt: 'Selecione um ou mais itens para continuar',
      },
      selected_rows: {
        es: 'filas seleccionadas',
        en: 'selected rows',
        pt: 'linhas selecionadas',
      },
      deselect_all: {
        es: 'Deseleccionar todos',
        en: 'Deselect all',
        pt: 'Desselecionar todos',
      },
      cancel: {
        es: 'Cancelar',
        en: 'Cancel',
        pt: 'Cancelar',
      },
      confirm: {
        es: 'Confirmar',
        en: 'Confirm',
        pt: 'Confirmar',
      },
      apply: {
        es: 'Aplicar',
        en: 'Apply',
        pt: 'Aplicar',
      },
      apply_filter: {
        es: 'Aplicar filtro',
        en: 'Apply filter',
        pt: 'Aplicar filtro',
      },
      apply_filters: {
        es: 'Aplicar filtros',
        en: 'Apply filters',
        pt: 'Aplicar filtros',
      },
      your_filters: {
        es: 'Tus filtros',
        en: 'Your filters',
        pt: 'Seus filtros',
      },
      apply_changes: {
        es: 'Aplicar cambios',
        en: 'Apply changes',
        pt: 'Aplicar alterações',
      },
      filters: {
        es: 'Filtros',
        en: 'Filters',
        pt: 'Filtros',
      },
      exclude: {
        es: 'Excluir',
        en: 'Exclude',
        pt: 'Excluir',
      },
      include: {
        es: 'Incluir',
        en: 'Include',
        pt: 'Incluir',
      },
      will_be_included: {
        es: 'Se incluirá',
        en: 'Will be included',
        pt: 'Se incluirá',
      },
      will_be_excluded: {
        es: 'Se excluirá',
        en: 'Will be excluded',
        pt: 'Se excluirá',
      },
      without_changes: {
        es: 'Sin cambios',
        en: 'Without changes',
        pt: 'Sem alterações',
      },
      clear_selection: {
        es: 'Borrar selección',
        en: 'Clear selection',
        pt: 'Excluir seleção',
      },
      no_filters_yet: {
        es: 'Todavía no hay filtros guardados.',
        en: 'There are no saved filters yet.',
        pt: 'Ainda não existem filtros salvos.',
      },
      save_filters_configuration: {
        es: 'Guardar configuración de filtros',
        en: 'Save filters configuration',
        pt: 'Salvar configuração de filtros',
      },
      save_filter: {
        es: 'Guardar filtro',
        en: 'Save filter',
        pt: 'Salvar filtro',
      },
      active: {
        es: 'Activo',
        en: 'Active',
        pt: 'Ativo',
      },
      partial_extraction: {
        es: 'Baja parcial',
        en: 'Partial extraction',
        pt: 'Extração parcial',
      },
      learn_more: {
        es: 'Conocer más',
        en: 'Learn more',
        pt: 'Saber mais',
      },
      reference: {
        es: 'Referencia',
        en: 'Reference',
        pt: 'Referência',
      },
      yes: {
        es: 'Sí',
        en: 'Yes',
        pt: 'Sim',
      },
      no: {
        es: 'No',
        en: 'No',
        pt: 'Não',
      },
      no_rows: {
        es: 'No hay datos para mostrar',
        en: 'No data to show',
        pt: 'Não há dados para mostrar ',
      },
      rows_per_page: {
        es: 'Filas por página',
        en: 'Rows per page',
        pt: 'Linhas por página',
      },
      no_recent_data: {
        es: 'Sin datos recientes',
        en: 'No recent data',
        pt: 'Sem dados recentes',
      },
      tagging: {
        es: 'Etiquetado',
        en: 'Tagging',
        pt: 'Etiquetagem',
      },
      perform_extraction: {
        es: 'Realizar extracción',
        en: 'Perform extraction',
        pt: 'Realizar extração',
      },
      download_certificate: {
        es: 'Descargar certificado',
        en: 'Download certificate',
        pt: 'Baixar certificado',
      },
      archive_silobag: {
        es: 'Archivar silobolsa',
        en: 'Archive silobag',
        pt: 'Arquivar silos bolsa',
      },
      ingress_users: {
        es: 'Ingresar usuarios a compartir',
        en: 'Enter users to share',
        pt: 'Usuários com quem deseja compartilhar',
      },
      retry: {
        es: 'Reintentar',
        en: 'Retry',
        pt: 'Tentar novamente',
      },
      expired: {
        es: 'Vencido',
        en: 'Expired',
        pt: 'Expirado',
      },
      beta: {
        es: 'BETA',
        en: 'BETA',
        pt: 'BETA',
      },
      beta_badge: {
        es: 'Funcionalidad en estado BETA: aún en pruebas pero bastante avanzada',
        en: 'Functionality in BETA state: still in testing but quite advanced',
        pt: 'Funcionalidade em fase BETA: ainda em testes, mas em etapas bastante avançadas',
      },
      toasts: {
        success: {
          authentication: {
            es: 'Usuario autenticado satisfactoriamente',
            en: 'User successfully authenticated',
            pt: 'Usuário autenticado com sucesso',
          },
          new_extraction: {
            es: 'Extracción realizada con éxito',
            en: 'Extraction successfully completed',
            pt: 'Extração concluída com sucesso',
          },
          exported_part_1: {
            es: 'Se exportaron',
            en: 'Exported',
            pt: 'Exportados',
          },
          exported_part_2: {
            es: 'silobolsas correctamente.',
            en: 'silobags successfully.',
            pt: 'silos bolsas compartilhados.',
          },
          certificate_downloaded: {
            es: 'Certificación descargada correctamente.',
            en: 'Certificate downloaded successfully.',
            pt: 'Certificação baixada corretamente.',
          },
          archived: {
            es: 'archivada correctamente.',
            en: 'archived successfully.',
            pt: 'arquivada corretamente.',
          },
          satellite_certification_generation_started: {
            es: 'La certificación satelital comenzó a generarse.',
            en: 'The satellite certification generation has started.',
            pt: 'A certificação satelital começou a ser gerada.',
          },
          spreadsheet_imported: {
            es: 'La planilla se importó correctamente.',
            en: 'The spreadsheet was imported successfully.',
            pt: 'A planilha foi importada corretamente.',
          },
          download_closure_spreadsheets: {
            es: 'Planilla de cierres descargada.',
            en: 'Closure spreadsheet downloaded.',
            pt: 'Planilha de fechamentos baixada.',
          },
          check_silobags_spreadsheet: {
            es: 'Planilla validada. Revisá las silobolsas antes de confirmar.',
            en: 'Spreadsheet validated. Check the silobags before confirming.',
            pt: 'Planilha validada. Revise os silos bolsa antes de confirmar.',
          },
          silobag_tags_updated: {
            es: 'Las etiquetas de la silobolsa se actualizaron correctamente.',
            en: 'The silobag tags were updated successfully.',
            pt: 'As etiquetas do silo bolsa foram atualizadas corretamente',
          },
          silobags_tags_updated_1: {
            es: 'Las etiquetas de',
            en: 'The tags of',
            pt: 'As etiquetas de',
          },
          silobags_tags_updated_2: {
            es: 'silobolsas se actualizaron correctamente.',
            en: 'silobag tags were updated successfully.',
            pt: 'silos bolsa foram atualizadas corretamente.',
          },
          extraction_report_exported: {
            es: 'Se exportaron {{count}} extracciones correctamente.',
            en: '{{count}} extractions exported successfully.',
            pt: '{{count}} extrações exportadas corretamente.',
          },
        },
        error: {
          export_failed: {
            es: 'No se pudo generar la exportación.',
            en: 'Failed to generate export.',
            pt: 'Não foi possível gerar a exportação.',
          },
          certificate_download: {
            es: 'No se pudo descargar la certificación de silo.',
            en: 'Failed to download silo certification.',
            pt: 'Não foi possível baixar a certificação de silo.',
          },
          archived_silobag: {
            es: 'No se pudo archivar la silobolsa',
            en: 'Failed to archive silobag',
            pt: 'Não foi possível arquivar o silo bolsa',
          },
          generating_report: {
            es: 'No se pudo generar el reporte',
            en: 'Failed to generate report',
            pt: 'Não foi possível gerar o relatório',
          },
          extraction_report_export_failed: {
            es: 'No se pudo generar el reporte de extracciones.',
            en: 'Failed to generate the extractions report.',
            pt: 'Não foi possível gerar o relatório de extrações.',
          },
          closure_spreadsheet_generation: {
            es: 'No se pudo generar la planilla de cierres.',
            en: 'Failed to generate closure spreadsheet.',
            pt: 'Não foi possível gerar a planilha de fechamentos.',
          },
          select_organization_before_apply: {
            es: 'Seleccioná nuevamente tu organización antes de aplicar los cambios.',
            en: 'Select your organization again before applying the changes.',
            pt: 'Selecione novamente a sua organização antes de realizar as alterações.',
          },
          restore_silobags: {
            es: 'No se pudieron restaurar las silobolsas seleccionadas.',
            en: 'Failed to restore the selected silobags.',
            pt: 'Não foi possível restaurar os silos bolsa selecionados.',
          },
          update_silobag_permissions: {
            es: 'No se pudieron actualizar los permisos de las silobolsas seleccionadas.',
            en: 'Failed to update the permissions of the selected silobags.',
            pt: 'Não foi possível atualizar as permissões dos silos bolsa selecionados.',
          },
          obtain_silobag_permissions: {
            es: 'No se pudieron obtener los permisos de las silobolsas seleccionadas.',
            en: 'Failed to obtain the permissions of the selected silobags.',
            pt: 'Não foi possível obter as permissões dos silos bolsa selecionados.',
          },
        },
        loading: {
          generating_report: {
            es: 'Generando reporte',
            en: 'Generating report',
            pt: 'Gerando relatório',
          },
          generating_extraction_report: {
            es: 'Generando reporte de extracciones...',
            en: 'Generating extractions report...',
            pt: 'Gerando relatório de extrações...',
          },
          generating_excel: {
            es: 'Generando archivo Excel',
            en: 'Generating Excel file',
            pt: 'Generando arquivo Excel',
          },
          generating_closure_spreadsheets: {
            es: 'Generando planilla de cierres',
            en: 'Generating closure spreadsheet',
            pt: 'Gerando planilha de fechamentos',
          },
          generating_certificate_in_silo: {
            es: 'Generando certificación de silo',
            en: 'Generating silo certification',
            pt: 'Gerando certificação de silo',
          },
          archiving_silobag: {
            es: 'Archivando silobolsa',
            en: 'Archiving silobag',
            pt: 'Arquivando silo bolsa',
          },
          preparing_satellite_certification: {
            es: 'Preparando certificación satelital',
            en: 'Preparing satellite certification',
            pt: 'Preparando certificação satelital',
          },
          generating_satellite_certification_part_1: {
            es: 'Generando certificación satelital para',
            en: 'Generating satellite certification for',
            pt: 'Gerando certificação satelital para',
          },
          importing_quality_sample_spreadsheet: {
            es: 'Importando planilla de muestras de calidad',
            en: 'Importing quality sample spreadsheet',
            pt: 'Importando planilha de amostras de qualidade',
          },
          preparing_quality_sample_spreadsheet: {
            es: 'Preparando planilla de muestras de calidad',
            en: 'Preparing quality sample spreadsheet',
            pt: 'Preparando planilha de amostras de qualidade',
          },
          validating_closure_spreadsheets: {
            es: 'Validando planilla de cierres',
            en: 'Validating closure spreadsheet',
            pt: 'Validando planilha de fechamentos',
          },
        },
      },
      error: {
        certificate_download_failed: {
          es: 'Certificate download failed with status',
          en: 'Certificate download failed with status',
          pt: 'Falha ao baixar certificado com status',
        },
        satellite_certification_generation_failed: {
          es: 'No se pudo generar la certificación satelital.',
          en: 'Failed to generate satellite certification.',
          pt: 'Não foi possível gerar a certificação satelital.',
        },
        no_silospro_for_satellite_certification: {
          es: 'No hay SilosPro para generar la certificación satelital.',
          en: 'There are no SilosPro to generate the satellite certification.',
          pt: 'Não há SilosPro para gerar certificação satelital.',
        },
        spreadsheet_downloaded_to_fix: {
          es: 'La planilla contiene errores. Se descargó una copia marcada para corregirlos.',
          en: 'The spreadsheet contains errors. A marked copy was downloaded to correct them.',
          pt: 'A planilha contém erro. Foi baixada uma cópia marcada para corrigi-los.',
        },
        spreadsheet_download_failed: {
          es: 'La planilla contiene errores, pero no se pudo descargar la copia marcada.',
          en: 'The spreadsheet contains errors, but the marked copy could not be downloaded.',
          pt: 'A planilha contém erros, mas não foi possível baixar a cópia marcada.',
        },
        quality_spreadsheet_download: {
          es: 'No se pudo descargar la planilla de muestras de calidad.',
          en: 'Failed to download the quality sample spreadsheet.',
          pt: 'Não foi possível descarregar a planilha de amostras de qualidade.',
        },
        spreadsheet_already_imported: {
          es: 'La planilla ya fue importada.',
          en: 'The spreadsheet has already been imported.',
          pt: 'A planilha já foi importada.',
        },
        spreadsheet_not_for_selected_silobag: {
          es: 'La planilla no corresponde a la silobolsa seleccionada.',
          en: 'The spreadsheet does not correspond to the selected silobag.',
          pt: 'A planilha não corresponde ao silo bolsa selecionado.',
        },
        empty_file: {
          es: 'El archivo seleccionado está vacío.',
          en: 'The selected file is empty.',
          pt: 'O arquivo selecionado está vazio.',
        },
        file_larger_than_5mb: {
          es: 'El archivo no puede superar los 5 MB.',
          en: 'The file cannot exceed 5 MB.',
          pt: 'O arquivo não pode ser maior que 5 MB.',
        },
        select_an_excel_file: {
          es: 'Seleccioná un archivo Excel con formato',
          en: 'Select an Excel file with format',
          pt: 'Selecione um arquivo no formato Excel',
        },
        no_available_silobags_for_spreadsheet: {
          es: 'No hay silobolsas disponibles para generar las plantillas.',
          en: 'There are no silobags available to generate the templates.',
          pt: 'Não há silos bolsa disponíveis para gerar as planilhas.',
        },
        failed_to_prepare_laboratory_templates: {
          es: 'No se pudieron preparar las plantillas de laboratorio.',
          en: 'Failed to prepare the laboratory templates.',
          pt: 'Não foi possível preparar as planilhas de laboratório.',
        },
        failed_to_read_closure_spreadsheet: {
          es: 'No se pudo leer la planilla de cierres.',
          en: 'Failed to read the closure spreadsheet.',
          pt: 'Não foi possível ler a planilha de fechamentos.',
        },
        failed_to_obtain_organization_tags: {
          es: 'No se pudieron obtener las etiquetas de la organización.',
          en: 'Failed to obtain the organization tags.',
          pt: 'Não foi possível obter as etiquetas da organização.',
        },
        failed_to_update_tags: {
          es: 'No se pudieron actualizar las etiquetas.',
          en: 'Failed to update the tags.',
          pt: 'Não foi possível atualizar as etiquetas.',
        },
      },
    },
    public: {},
    private: {
      list: {
        common: {
          bagged_tons: {
            es: 'Tn embolsadas',
            en: 'Bagged tn',
            pt: 'Tn embolsadas',
          },
          extracted_tons: {
            es: 'Tn extraídas',
            en: 'Extracted tn',
            pt: 'Tn extraídas',
          },
          actives: {
            es: 'Activos',
            en: 'Actives',
            pt: 'Ativos',
          },
          new_extraction: {
            es: 'Nueva extracción',
            en: 'New extraction',
            pt: 'Nova extração',
          },
          register_date: {
            es: 'Fecha de alta',
            en: 'Register date',
            pt: 'Data alta',
          },
          see_on_map: {
            es: 'Ver en mapa',
            en: 'See on map',
            pt: 'Ver no mapa',
          },
          humidity_level: {
            es: 'Nivel de humedad',
            en: 'Humidity level',
            pt: 'Nível de umidade',
          },
          extracted: {
            es: 'Extraído',
            en: 'Extracted',
            pt: 'Extraído',
          },
          no_extractions: {
            es: 'Sin bajas',
            en: 'No extractions',
            pt: 'Sem extrações',
          },
          archived: {
            es: 'Archivados',
            en: 'Archived',
            pt: 'Arquivados',
          },
          copy_id: {
            es: 'Copiar ID',
            en: 'Copy ID',
            pt: 'Copiar ID',
          },
          copied: {
            es: 'Copiado',
            en: 'Copied',
            pt: 'Copiado',
          },
          view_in_map: {
            es: 'Ver en mapa',
            en: 'View in map',
            pt: 'Ver no mapa',
          },
          quote_iwarrant: {
            es: 'Cotizá tu iWarrant',
            en: 'Quote your iWarrant',
            pt: 'Cotar iWarrant',
          },
          selected_silobag: {
            es: 'silobolsa seleccionado',
            en: 'selected silobag',
            pt: 'silo bolsa selecionado',
          },
          selected_silobags: {
            es: 'silobolsas seleccionadas',
            en: 'selected silobags',
            pt: 'silos bolsas selecionados',
          },
          actions: {
            upload_spreadsheet: {
              es: 'Cargar planilla',
              en: 'Upload spreadsheet',
              pt: 'Carregar planilha',
            },
            download_silospro_silobags_spreadsheet: {
              es: 'Descargar planilla de SilosPro + Silobolsas',
              en: 'Download SilosPro + Silobags spreadsheet',
              pt: 'Baixar planilha de SilosPro + Silobolsas',
            },
            download_silospro_spreadsheet: {
              es: 'Descargar planilla de SilosPro',
              en: 'Download SilosPro spreadsheet',
              pt: 'Baixar planilha de SilosPro',
            },
            download_silobag_spreadsheet: {
              es: 'Descargar planilla de Silobolsas',
              en: 'Download Silobags spreadsheet',
              pt: 'Baixar planilha de Silos bolsas',
            },
            global_exports: {
              es: 'Exportaciones globales',
              en: 'Global exports',
              pt: 'Exportações globais',
            },
            silospro_silobags_report: {
              es: 'Reporte de SilosPro + Silobolsas',
              en: 'SilosPro + Silobags report',
              pt: 'Relatório de SilosPro + Silos Bolsas',
            },
            silospro_report: {
              es: 'Reporte de SilosPro',
              en: 'SilosPro report',
              pt: 'Relatório de SilosPro',
            },
            silobag_report: {
              es: 'Reporte de Silobolsas',
              en: 'Silobags report',
              pt: 'Relatório de Silos Bolsas',
            },
            extraction_report: {
              es: 'Reporte de Extracciones',
              en: 'Extractions report',
              pt: 'Relatório de Extrações',
            },
            silospro_satellite_certification: {
              es: 'Certificación satelital SilosPro',
              en: 'SilosPro satellite certification',
              pt: 'Certificação satelital SilosPro',
            },
            download_model_spreadsheet: {
              es: 'Descargar planilla modelo',
              en: 'Download model spreadsheet',
              pt: 'Baixar planilha modelo',
            },
          },
          extraction_report: {
            status: {
              active: {
                es: 'Activo',
                en: 'Active',
                pt: 'Ativo',
              },
              closed: {
                es: 'Cerrado',
                en: 'Closed',
                pt: 'Fechado',
              },
            },
            columns: {
              id: {
                es: 'ID',
                en: 'ID',
                pt: 'ID',
              },
              silobag_name: {
                es: 'Nombre SB',
                en: 'Silobag name',
                pt: 'Nome SB',
              },
              organization: {
                es: 'Organización',
                en: 'Organization',
                pt: 'Organização',
              },
              countryside: {
                es: 'Establecimiento',
                en: 'Farm',
                pt: 'Estabelecimento',
              },
              countryside_zone: {
                es: 'Zona / Sucursal',
                en: 'Zone / Branch',
                pt: 'Região',
              },
              lot: {
                es: 'Lote Stock',
                en: 'Stock lot',
                pt: 'Talhão Estoque',
              },
              origin_lot: {
                es: 'Lote Origen',
                en: 'Origin lot',
                pt: 'Talhão Origem',
              },
              species: {
                es: 'Especie',
                en: 'Species',
                pt: 'Cultura',
              },
              humidity: {
                es: 'Humedad',
                en: 'Humidity',
                pt: 'Umidade',
              },
              status: {
                es: 'Estado',
                en: 'Status',
                pt: 'Estado',
              },
              extraction_date: {
                es: 'Fecha de extracción',
                en: 'Extraction date',
                pt: 'Data de extração',
              },
              user: {
                es: 'Usuario',
                en: 'User',
                pt: 'Usuário',
              },
              freight: {
                es: 'Int. flete',
                en: 'Freight broker',
                pt: 'Agente de frete',
              },
              transport: {
                es: 'Transporte',
                en: 'Transport',
                pt: 'Transporte',
              },
              driver: {
                es: 'Chofer',
                en: 'Driver',
                pt: 'Motorista',
              },
              chassis_plate: {
                es: 'Patente chasis',
                en: 'Chassis plate',
                pt: 'Placa Cavalo',
              },
              trailer_plate: {
                es: 'Patente acoplado',
                en: 'Trailer plate',
                pt: 'Placa Carreta',
              },
              ctg: {
                es: 'CTG (Código de Transporte de Granos)',
                en: 'CTG (Grain Transport Code)',
                pt: 'CRG (Código de Rastrerabilidade de grãos)',
              },
              waybill: {
                es: 'CP',
                en: 'Waybill',
                pt: 'CEP',
              },
              contract: {
                es: 'Contrato',
                en: 'Contract',
                pt: 'Contrato',
              },
              destination: {
                es: 'Destino (Comprador)',
                en: 'Destination (Buyer)',
                pt: 'Destino (Comprador)',
              },
              gross_weight: {
                es: 'Peso bruto',
                en: 'Gross weight',
                pt: 'Peso Bruto',
              },
              tare: {
                es: 'Tara',
                en: 'Tare',
                pt: 'Tara',
              },
              net_weight: {
                es: 'Neto',
                en: 'Net weight',
                pt: 'Liquido',
              },
              observations: {
                es: 'Observaciones',
                en: 'Observations',
                pt: 'Observações',
              },
              data_status: {
                es: 'Validado',
                en: 'Validated',
                pt: 'Validado',
              },
            },
          },
          export: {
            in_selection: {
              es: 'en selección',
              en: 'in selection',
              pt: 'selecionados',
            },
            with_active_filter: {
              es: 'y con filtro activo',
              en: 'and with active filter',
              pt: 'e com filtro ativo',
            },
          },
          massive_tagging_modal: {
            title: {
              es: 'Etiquetado masivo',
              en: 'Massive tagging',
              pt: 'Etiquetagem em massa',
            },
            sub_title: {
              es: 'Definí los cambios que se aplicarán a',
              en: 'Define the changes that will be applied to',
              pt: 'Defina as alterações que serão aplicadas a',
            },
            informative: {
              es: 'Elegí Incluir o Excluir para cada etiqueta. Si volvés a presionar la opción seleccionada, la etiqueta quedará sin cambios.',
              en: 'Choose Include or Exclude for each tag. If you press the selected option again, the tag will remain unchanged.',
              pt: 'Selecione incluir ou excluir para cada etiqueta. Se clicar duas vezes na opção selecionada, a etiqueta permanecerá sem alterações.',
            },
            question: {
              es: '¿Necesitás una etiqueta que no esté en la lista?',
              en: 'Do you need a tag that is not on the list?',
              pt: 'Precisa de uma etiqueta que não está na lista?',
            },
            contact: {
              es: 'Contactá al administrador de tu compañía para solicitar nuevas etiquetas.',
              en: 'Contact your company administrator to request new tags.',
              pt: 'Contacte o administrador da sua empresa para solicitar novas etiquetas.',
            },
            no_changes_selected: {
              es: 'Todavía no seleccionaste cambios.',
              en: 'You have not selected any changes yet.',
              pt: 'Nenhuma alteração foi selecionada.',
            },
            to_include: {
              es: 'para incluir',
              en: 'to include',
              pt: 'para incluir',
            },
            to_exclude: {
              es: 'para excluir',
              en: 'to exclude',
              pt: 'para excluir',
            },
            alert_no_tags_in_organization: {
              es: 'No hay etiquetas disponibles para tu organización.',
              en: 'There are no tags available for your organization.',
              pt: 'Não há etiquetas disponíveis para a sua organização.',
            },
            alert_failed_to_obtain_tags: {
              es: 'No se pudieron obtener las etiquetas de la organización.',
              en: 'Failed to obtain the organization tags.',
              pt: 'Não foi possível obter as etiquetas da organização.',
            },
            obtaining_tags: {
              es: 'Obteniendo etiquetas disponibles',
              en: 'Obtaining available tags',
              pt: 'Obtendo as etiquetas disponíveis',
            },
          },
        },
        silospro: {
          silospro: {
            es: 'SilosPro',
            en: 'SilosPro',
            pt: 'SilosPro',
          },
          without_vrr: {
            es: 'Sin VRR',
            en: 'Without VRR',
            pt: 'Sem VRR',
          },
          with_vrr: {
            es: 'Con VRR',
            en: 'With VRR',
            pt: 'Com VRR',
          },
          ready_to_operate: {
            es: 'Tus SilosPro, listos para operar.',
            en: 'Your SilosPro, ready to operate.',
            pt: 'Seus SilosPro, prontos para operações',
          },
          from_your_silospro_stock: {
            es: 'De tu stock de SilosPro',
            en: 'From your SilosPro stock',
            pt: 'Do seu estoque de SilosPro',
          },
          insured: {
            es: 'Asegurados',
            en: 'Insured',
            pt: 'Assegurados',
          },
          close_silopro: {
            es: 'Cerrar SiloPro',
            en: 'Close SiloPro',
            pt: 'Fechar SiloPro',
          },
          vrr: {
            es: 'VRR',
            en: 'VRR',
            pt: 'VRR',
          },
          vri: {
            es: 'VRI',
            en: 'VRI',
            pt: 'VRI',
          },
          insure: {
            es: 'Asegurá',
            en: 'Insure',
            pt: 'Assegure',
          },
          insure_your_silospro: {
            es: 'Asegurá tu SiloPro',
            en: 'Insure your SiloPro',
            pt: 'Assegure seu SiloPro',
          },
          quote: {
            es: 'Cotizá',
            en: 'Quote',
            pt: 'Cotar',
          },
          initializing: {
            es: 'Inicializando',
            en: 'Initializing',
            pt: 'Iniciando',
          },
          vrr_ok: {
            es: 'VRR OK',
            en: 'VRR OK',
            pt: 'VRR OK',
          },
          vrr_not_ok: {
            es: 'VRR NO OK',
            en: 'VRR NO OK',
            pt: 'VRR NÃO OK',
          },
          vri_approved: {
            es: 'VRI APROBADA',
            en: 'VRI APPROVED',
            pt: 'VRI APROVADA',
          },
          vri_rejected: {
            es: 'VRI RECHAZADA',
            en: 'VRI REJECTED',
            pt: 'VRI REJEITADA',
          },
          vri_pending: {
            es: 'VRI PENDIENTE',
            en: 'VRI PENDING',
            pt: 'VRI PENDENTE',
          },
          vri_level: {
            es: 'Nivel',
            en: 'Level',
            pt: 'Nível',
          },
          from_your_total_stock: {
            es: 'De tu stock total',
            en: 'From your total stock',
            pt: 'Do seu estoque total',
          },
          guarantees: {
            es: 'Garantías',
            en: 'Guarantees',
            pt: 'Garantias',
          },
          view_inconsistencies: {
            es: 'Ver inconsistencias',
            en: 'View inconsistencies',
            pt: 'Ver inconsistências',
          },
          view_silopro: {
            es: 'Ver SiloPro',
            en: 'View SiloPro',
            pt: 'Ver SiloPro',
          },
          edit_silopro: {
            es: 'Editar SiloPro',
            en: 'Edit SiloPro',
            pt: 'Editar SiloPro',
          },
          export: {
            with_vrr: {
              spreadsheet: {
                es: 'Planilla de SilosPro con VRR',
                en: 'SilosPro with VRR spreadsheet',
                pt: 'Planilha de SilosPro com VRR',
              },
              report: {
                es: 'Reporte de SilosPro con VRR',
                en: 'SilosPro with VRR report',
                pt: 'Relatório de SilosPro com VRR',
              },
              satellite_certificate: {
                es: 'Certificación satelital de SilosPro con VRR',
                en: 'SilosPro with VRR satellite certification',
                pt: 'Certificação satelital de SilosPro com VRR',
              },
            },
            without_vrr: {
              spreadsheet: {
                es: 'Planilla de SilosPro sin VRR',
                en: 'SilosPro without VRR spreadsheet',
                pt: 'Planilha de SilosPro sem VRR',
              },
              report: {
                es: 'Reporte de SilosPro sin VRR',
                en: 'SilosPro without VRR report',
                pt: 'Relatório de SilosPro sem VRR',
              },
              satellite_certificate: {
                es: 'Certificación satelital de SilosPro sin VRR',
                en: 'SilosPro without VRR satellite certification',
                pt: 'Certificação satelital de SilosPro sem VRR',
              },
            },
            closed: {
              spreadsheet: {
                es: 'Planilla de SilosPro cerrados',
                en: 'Closed SilosPro spreadsheet',
                pt: 'Planilha de SilosPro fechados',
              },
              report: {
                es: 'Reporte de SilosPro cerrados',
                en: 'Closed SilosPro report',
                pt: 'Relatório de SilosPro fechados',
              },
            },
          },
          silopro_closure_modal: {
            accounting_closure: {
              es: 'Cierre contable',
              en: 'Accounting closure',
              pt: 'Fechamento declarado',
            },
            check_selection: {
              es: 'Verificá la selección',
              en: 'Check the selection',
              pt: 'Verifique a seleção',
            },
            next_closure: {
              es: 'Se realizará el siguiente cierre',
              en: 'The following closure will be performed',
              pt: 'Será realizado o seguinte fechamento', // CHECK 'seguinte' ?
            },
            will_be_closed: {
              es: 'Se cerrará',
              en: 'Will be closed',
              pt: 'Será fechado',
            },
            confirm_closure: {
              es: 'Confirmar cierre',
              en: 'Confirm closure',
              pt: 'Confirmar fechamento',
            },
            validating: {
              es: 'Validando permisos, estado y monitoreo...',
              en: 'Validating permissions, status and monitoring...',
              pt: 'Validando permissões, estado e monitoramento...',
            },
            will_be_performed: {
              es: 'Se realizarán',
              en: 'Will be performed',
              pt: 'Se realizaram',
            },
            nothing_available_to_close: {
              es: 'No hay nada disponible para cerrar',
              en: 'There is nothing available to close',
              pt: 'Não há nada disponível para fechamento',
            },
            there_is: {
              es: 'Hay',
              en: 'There is',
              pt: 'Há',
            },
            available_to_close: {
              es: 'disponibles para cerrar',
              en: 'available to close',
              pt: 'disponíveis para fechamento',
            },
            left_out_of_closure: {
              es: 'quedaron fuera del cierre',
              en: 'were left out of the closure',
              pt: 'ficaram fora da seleção para fechamento',
            },
            one_left_out_of_closure: {
              es: '1 selección quedó fuera del cierre',
              en: '1 selection was left out of the closure',
              pt: '1 item ficou fora da seleção para fechamento',
            },
            could_not_be_validated: {
              es: 'No se pudo validar la selección',
              en: 'The selection could not be validated',
              pt: 'Não foi possível validar a seleção',
            },
            continue_with: {
              es: 'Continuar con',
              en: 'Continue with',
              pt: 'Continuar com',
            },
            could_not_be_performed: {
              es: 'No se pudieron realizar los siguientes cierres. Revisá el motivo antes de continuar',
              en: 'The following closures could not be performed. Check the reason before continuing',
              pt: 'Não foi possível realizar os fechamentos em questão. Revise o motivo antes de continuar',
            },
            retry_verify: {
              es: 'Reintentá para verificar permiso y estado',
              en: 'Retry to verify permission and status',
              pt: 'Tente novamente para verificar a permissão e o estado',
            },
            getting_selection_data: {
              es: 'Estamos obteniendo los datos de la selección',
              en: 'We are getting the data of the selection',
              pt: 'Estamos obtendo os dados da seleção',
            },
            verify_selection: {
              es: 'Revisá la selección',
              en: 'Check the selection',
              pt: 'Revisar a seleção',
            },
            validating_closure: {
              es: 'Validando cierre',
              en: 'Validating closure',
              pt: 'Validando o fechamento',
            },
            could_not_validate_closure: {
              es: 'No se pudo validar el cierre',
              en: 'The closure could not be validated',
              pt: 'Não foi possível validar o fechamento',
            },
            closures: {
              es: 'cierres',
              en: 'closures',
              pt: 'fechamentos',
            },
            silobags_more: {
              es: 'silobolsas más',
              en: 'silobags more',
              pt: 'silos bolsa',
            },
            and: {
              es: 'Y',
              en: 'And',
              pt: 'E outros',
            },
            closed_label: {
              es: 'Ya está cerrado',
              en: 'Already closed',
              pt: 'Já está fechado',
            },
            not_found_label: {
              es: 'No se encontró o no está disponible',
              en: 'Not found or not available',
              pt: 'Não foi encontrado ou não está disponível',
            },
            permission_label: {
              es: 'Sin permiso de escritura',
              en: 'Without write permission',
              pt: 'Sem permissão de edição',
            },
            vrr_label: {
              es: 'Requiere el proceso de cierre VRR',
              en: 'Requires the VRR closure process',
              pt: 'Necessário o processo de fechamento VRR',
            },
            could_not_perform_closure: {
              es: 'No se pudo realizar ningún cierre',
              en: 'Could not perform any closure',
              pt: 'Não foi possível realizar nenhum fechamento',
            },
            could_not_perform_single_closure: {
              es: 'No se pudo realizar el cierre',
              en: 'Could not perform the closure',
              pt: 'Não foi possível realizar o fechamento',
            },
            success: {
              es: 'Se realizó el cierre correctamente',
              en: 'The closure was performed successfully',
              pt: 'O fechamento foi realizado corretamente',
            },
            performed: {
              es: 'Se realizaron',
              en: 'They were performed',
              pt: 'Foram realizados',
            },
            success_end: {
              es: 'cierres correctamente',
              en: 'closures successfully',
              pt: 'fechamentos corretamente',
            },
            closures_but: {
              es: 'cierres, pero',
              en: 'closures, but',
              pt: 'fechamentos, mas',
            },
            could_not_be_closed: {
              es: 'no pudieron cerrarse',
              en: 'could not be closed',
              pt: 'não foi possível fechar',
            },
            warning_modal_wrong_extraction: {
              es: 'La extracción solicitada es mayor a la cantidad de producto almacenado, ¿Desea continuar con la operación?',
              en: 'The requested extraction is greater than the amount of stored product, do you want to continue with the operation?',
              pt: 'A extração solicitada é maior que a quantidade de produto armazenado. Deseja continuar com a operação?',
            },
          },
        },
        silobag: {
          return_silospro: {
            es: 'Volver a SilosPro',
            en: 'Return to SilosPro',
            pt: 'Retornar ao SilosPro',
          },
          individual_register: {
            es: 'Alta individual',
            en: 'Individual register',
            pt: 'Registro individual',
          },
          massive_register: {
            es: 'Alta masiva mediante planilla',
            en: 'Massive register through spreadsheet',
            pt: 'Registro múltiplo através de planilha',
          },
          download_model_spreadsheet: {
            es: 'Descargar planilla modelo',
            en: 'Download model spreadsheet',
            pt: 'Baixar planilha modelo',
          },
          from_your_silobags_stock: {
            es: 'De tu stock de Silobolsas',
            en: 'From your silobags stock',
            pt: 'Do seu estoque de Silos bolsa',
          },
          validate_your_silobags_at_origin_for_service: {
            es: 'Validá tus silobolsas en origen para poder activar los servicios',
            en: 'Validate your silobags at origin to be able to activate the services',
            pt: 'Valide seus silos bolsa em campo para poder ativar os serviços',
          },
          validate_your_silobags_at_origin: {
            es: 'Validá tus silobolsas en origen y activá todo el potencial del sistema.',
            en: 'Validate your silobags at origin and activate the full potential of the system.',
            pt: 'Valide seus silos bolsa em campo para ativar todo o potencial do sistema',
          },
          secure_with_a_single_step: {
            es: 'Asegurá tus granos y habilitá el monitoreo satelital con un solo paso.',
            en: 'Secure your grains and enable satellite monitoring with a single step.',
            pt: 'Assegure seus grãos e habilite o monitoramento satelital com um único passo',
          },
          must_have_countryside: {
            es: 'Se tiene que crear un establecimiento antes de crear silobolsas. Ver dentro de pestaña Administrados > Establecimientos > +Nuevo Establecimiento.',
            en: 'You must create a countryside before creating silobags. See inside the Managed tab > Countrysides > +New Countryside.',
            pt: 'É necessário criar um estabelecimento antes de criar silos bolsa. Para isso, abra a página de Administrador > Estabelecimentos > +Novo Estabelecimento',
          },
          restore: {
            es: 'Restaurar',
            en: 'Restore',
            pt: 'Restaurar',
          },
          view_silobag: {
            es: 'Ver silobolsa',
            en: 'View silobag',
            pt: 'Ver silos bolsa',
          },
          edit_silobag: {
            es: 'Editar silobolsa',
            en: 'Edit silobag',
            pt: 'Editar silo bolsa',
          },
          close_silobag: {
            es: 'Cerrar Silobolsa',
            en: 'Close Silobag',
            pt: 'Fechar Silo bolsa',
          },
          export: {
            active: {
              spreadsheet: {
                es: 'Planilla de Silobolsas activos',
                en: 'Active Silobags spreadsheet',
                pt: 'Planilha de Silos Bolsas ativos',
              },
              report: {
                es: 'Reporte de Silobolsas activos',
                en: 'Active Silobags report',
                pt: 'Relatório de Silos Bolsas ativos',
              },
            },
            closed: {
              spreadsheet: {
                es: 'Planilla de Silobolsas cerrados',
                en: 'Closed Silobags spreadsheet',
                pt: 'Planilha de Silos Bolsas fechados',
              },
              report: {
                es: 'Reporte de Silobolsas cerrados',
                en: 'Closed Silobags report',
                pt: 'Relatório de Silos Bolsas fechados',
              },
            },
          },
          silobag_info_modal: {
            title_1: {
              es: 'Da de alta tu silobolsa y completá el proceso en origen',
              en: 'Register your silobag and complete the process at origin',
              pt: 'Registre seu silo bolsa e complete o processo em campo',
            },
            content_1: {
              es: 'Para que tu silobolsa quede ',
              en: 'So that your silobag is ',
              pt: 'Para que o seu silo bolsa seja ',
            },
            content_2: {
              es: 'validada',
              en: 'validated',
              pt: 'validado',
            },
            content_3: {
              es: ', realizá el ',
              en: ', perform the ',
              pt: ', realize o ',
            },
            content_4: {
              es: 'Alta en origen',
              en: 'Registration at origin',
              pt: 'Registro em campo',
            },
            content_5: {
              es: ' desde la ',
              en: ' from the ',
              pt: ' através do ',
            },
            content_6: {
              es: 'app móvil.',
              en: 'mobile app.',
              pt: 'app mobile.',
            },
            content_7: {
              es: 'De esta forma se registra con ',
              en: 'In this way it is registered with ',
              pt: 'Dessa forma eles terão verificadas suas ',
            },
            content_8: {
              es: 'georreferencia',
              en: 'georeference',
              pt: 'georreferências',
            },
            content_9: {
              es: ' y ',
              en: ' and ',
              pt: ' e ',
            },
            content_10: {
              es: 'accedés a todas las',
              en: 'you access all the',
              pt: 'poderão acessar todas as ',
            },
            content_11: {
              es: 'funcionalidades disponibles.',
              en: 'available functionalities.',
              pt: 'funcionalidades disponíveis.',
            },
            title_advantages: {
              es: 'Desde la web podés iniciar la carga de datos, pero el Alta en origen desde la app te permite:',
              en: 'From the web you can start the data upload, but the registration at origin from the app allows you to:',
              pt: 'A partir da plataforma web você poderá iniciar o cadastro de dados, mas apenas com o registro em campo o app te permite:',
            },
            advantage_1: {
              es: 'Validar tu silobolsa con ubicación exacta en el mapa.',
              en: 'Validate your silobag with exact location on the map.',
              pt: 'Validar seu silo bolsa com a localização exata no mapa.',
            },
            advantage_2_1: {
              es: 'Habilitar el monitoreo satelital con ',
              en: 'Enable satellite monitoring with ',
              pt: 'Habilitar o monitoramento satelital com ',
            },
            advantage_2_2: {
              es: 'SiloSat.',
              en: 'SiloSat.',
              pt: 'SiloSat.',
            },
            advantage_3_1: {
              es: 'Asegurar tus granos',
              en: 'Secure your grains',
              pt: 'Assegurar seus grãos',
            },
            advantage_3_2: {
              es: ' mediante ',
              en: ' through ',
              pt: ' através do ',
            },
            advantage_3_3: {
              es: 'SiloSeguro, Warrant o iWarrant.',
              en: 'SiloSeguro, Warrant or iWarrant.',
              pt: 'SiloSeguro ou registrá-lo em uma CPR.',
            },
            title_2: {
              es: 'Descargá la app y validá tu silobolsa',
              en: 'Download the app and validate your silobag',
              pt: 'Baixe o app e valide seus silos bolsa',
            },
            play_store_src: {
              es: '/google-play-store/get-it-on-google-play-es.svg',
              en: '/google-play-store/get-it-on-google-play-en.svg',
              pt: '/google-play-store/get-it-on-google-play-pt-br.svg',
            },
            download_in_google_play: {
              es: 'Descargar en Google Play Store',
              en: 'Download in Google Play Store',
              pt: 'Baixar no Google Play Store',
            },
            download_in_apple_store: {
              es: 'Descargar en Apple Store',
              en: 'Download in Apple Store',
              pt: 'Baixar na Apple Store',
            },
            app_store_src: {
              es: '/apple-store/download-on-apple-store-es.svg',
              en: '/apple-store/download-on-apple-store-en.svg',
              pt: '/apple-store/download-on-apple-store-pt-br.svg',
            },
            footer_question: {
              es: '¿Tenés dudas?',
              en: 'Do you have questions?',
              pt: 'Possui alguma dúvida?',
            },
            footer_answer_1: {
              es: 'Consultá el ',
              en: 'Check the ',
              pt: 'Consulte o ',
            },
            footer_answer_2: {
              en: 'Manual del Usuario',
              es: 'User Manual',
              pt: 'Manual do Usuário',
            },
            footer_answer_3: {
              es: ' para ver los pasos completos y ejemplos.',
              en: ' to see the complete steps and examples.',
              pt: ' para ver os passos completos e exemplos.',
            },
          },
        },
      },
    },
  },
} satisfies TranslationNode;
